<template>
  <!-- 报表下载 -->
  <div class="Content">
    <el-card>
      <el-form ref="form" :model="form" label-width="120px" size="mini">
        <el-form-item label="品牌">
          <el-select v-model="form.brand" filterable @change="brandChange">
            <!-- <el-option label="全部" value=""> </el-option> -->
            <el-option
              v-for="item in BrandList"
              :key="item.brand"
              :label="item.brand"
              :value="item.brand"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="大区" v-if="form.brand">
          <el-select v-model="form.zone" filterable @change="zoneChange">
            <!-- <el-option label="全部" value=""> </el-option> -->
            <el-option
              v-for="item in ZoneList"
              :key="item.zone"
              :label="item.zone"
              :value="item.zone"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经销商名称" v-if="form.brand && form.zone">
          <el-select v-model="form.cid" filterable>
            <el-option label="全部" value=""> </el-option>
            <el-option
              v-for="item in DealernameList"
              :key="item.cid"
              :label="item.dealername"
              :value="item.cid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报表类型">
          <el-select v-model="form.Type" placeholder="请选择">
            <el-option
              :key="item.id"
              :value="item.id"
              :label="item.name"
              v-for="item in BBList"
            >
              {{ item.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <div class="dateCss">
            <el-date-picker
              v-model="form.Timer"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <div class="tabs">
              <span
                @click="DateTabs('day')"
                :class="[TimeType == 'day' ? 'timeAct' : '']"
                >今日</span
              >
              <span
                @click="DateTabs('week')"
                :class="[TimeType == 'week' ? 'timeAct' : '']"
                >本周</span
              >
              <span
                @click="DateTabs('month')"
                :class="[TimeType == 'month' ? 'timeAct' : '']"
                >本月</span
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="allDownFile">下 载</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { exportExcel } from "../../utils/DownLoadFail.js";
import {
  formatDate,
  getMonthDays,
  getWeekStartDate,
  getMonthEndDate,
  getMonthStartDate,
  getWeekEndDate
} from "../../utils/Date.js";
export default {
  data() {
    return {
      form: {
        brand: "",
        Timer: [
          new Date(new Date().getTime()).Format("YYYY-MM-DD"),
          new Date(new Date().getTime()).Format("YYYY-MM-DD")
        ],
        Type: 1,
        cid: "",
        zone: ""
      },
      TimeType: "day",
      BBList: [
        {
          id: 1,
          name: "DCC评分详情（录音详情-DCC呼出）"
        },
        {
          id: 2,
          name: "首次进店评分详情（录音详情-首次进店）"
        },
        {
          id: 3,
          name: "通话记录"
        },
        {
          id: 4,
          name: "线索跟进结果"
        },
        {
          id: 5,
          name: "接待数据录入"
        },
        {
          id: 6,
          name: "DCC呼入报表"
        }
      ],
      BrandList: [],
      DealernameList: [],
      ZoneList: []
    };
  },
  methods: {
    brandChange(e) {
      console.log(e);
      this.form.zone = "";
      this.form.cid = "";
      this.ZoneList = [];
      this.getZoneFun();
    },
    zoneChange(e) {
      console.log(e);
      this.form.cid = "";
      this.DealernameList = [];
      this.getDealerListFun();
    },
    async DownLoadFile(HEADER, FIELD, DATA, NAME) {
      console.log(HEADER, FIELD, DATA, NAME);
      console.log(new Date().getTime());
      // return
      await exportExcel(HEADER, FIELD, DATA, NAME);
      console.log(new Date().getTime());
    },
    DateTabs(type) {
      this.TimeType = type;
      switch (type) {
        case "day":
          console.log(type);
          this.form.Timer = [
            new Date(new Date().getTime()).Format("YYYY-MM-DD"),
            new Date(new Date().getTime()).Format("YYYY-MM-DD")
          ];
          break;
        case "week":
          console.log(type);
          this.form.Timer = [
            getWeekStartDate(),
            new Date(new Date().getTime()).Format("YYYY-MM-DD")
          ];
          break;
        case "month":
          console.log(type);
          this.form.Timer = [
            getMonthStartDate(),
            new Date(new Date().getTime()).Format("YYYY-MM-DD")
          ];
          break;
        default:
          break;
      }
    },
    // 获取品牌
    getBrandFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getBrand", {
          data: JSON.stringify(this.$Help({}))
        })
        .then(res => {
          loading.close();
          console.log(res);
          this.BrandList = res.data.filter(item => item.brand);
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    },
    // 获取经销商
    getDealerListFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getDealerList", {
          data: JSON.stringify(
            this.$Help({
              pageindex: "1",
              pagesize: "0",
              brand: this.form.brand,
              zone: this.form.zone,
              dealername: ""
            })
          )
        })
        .then(res => {
          loading.close();
          console.log(res);
          this.DealernameList = res.data.detail;
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    },
    // 获取区域
    getZoneFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getZone", {
          data: JSON.stringify(
            this.$Help({
              brand: this.form.brand
            })
          )
        })
        .then(res => {
          loading.close();
          console.log(res);
          this.ZoneList = res.data.filter(item => item.zone);
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    },

    // 下载报表方法
    allDownFile() {
      // if (!this.form.cid) return
      switch (this.form.Type) {
        case 0:
          this.Getscorelistdetail_header("DCC呼出");
          this.Getscorelistdetail_header("首次进店");
          this.downLoadCallLog();
          this.downLoadClueResults();
          this.GetAllInfo();
          break;
        case 1:
          this.Getscorelistdetail_header("DCC呼出");
          break;
        case 2:
          this.Getscorelistdetail_header("首次进店");
          break;
        case 3:
          this.downLoadCallLog();
          break;
        case 4:
          this.downLoadClueResults();
          break;
        case 5:
          // this.downLoadClueResults()
          this.GetAllInfo();
          break;
        case 6:
          this.Getscorelistdetail_header("DCC呼入");
          break;
        default:
          break;
      }
    },

    // 获取表头
    Getscorelistdetail_header(type) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getscorelistdetail_header", {
          data: JSON.stringify(
            this.$Help({
              cid: this.form.cid,
              brand: this.form.brand,
              zone: this.form.zone,
              pageindex: 1,
              pagesize: 10,
              actname: "",
              vtype: type,
              time1: this.form.Timer[0],
              time2: this.form.Timer[1],
              username: ""
            })
          )
        })
        .then(res => {
          loading.close();
          // console.log(res);
          if (res.length == 0) return;
          let tablehead = [];
          let TableHead2 = [];
          res.data.forEach((item, index) => {
            // console.log(item);
            tablehead.push(`${index + 1}.${Object.keys(item)[0]}`);
            TableHead2.push(Object.keys(item)[0]);
            if (item[Object.keys(item)[0]]) {
              let firstdata = item[Object.keys(item)[0]];
              firstdata.forEach((item2, index2) => {
                tablehead.push(
                  `${index + 1}.${index2 + 1}.${Object.keys(item2)[0]}`
                );
                TableHead2.push(Object.keys(item2)[0]);
                let seconddata = item2[Object.keys(item2)[0]];
                if (seconddata.length != 0) {
                  seconddata.forEach((item3, index3) => {
                    tablehead.push(
                      `${index + 1}.${index2 + 1}.${index3 + 1}.${item3}`
                    );
                    TableHead2.push(item3);
                  });
                }
              });
            }
          });
          // console.log(TableHead2, tablehead);
          // return
          this.getScoreListDetail(tablehead, TableHead2, type);
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    },
    getScoreListDetail(TABLEHEAD, TABLEHEADSHOW, type) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getscorelistdetail", {
          data: JSON.stringify(
            this.$Help({
              cid: this.form.cid,
              brand: this.form.brand,
              zone: this.form.zone,
              pageindex: 1,
              pagesize: "0",
              actname: "",
              vtype: type,
              time1: this.form.Timer[0],
              time2: this.form.Timer[1],
              username: ""
            })
          )
        })
        .then(res => {
          console.log(res);
          loading.close();
          let data = res.data;
          let tabledata = []; // 数据
          let Tablehead = []; // 表头
          if (data.detail.length != 0) {
            data.detail.forEach((dataobj, idx) => {
              let rowobj = {}; //对象
              Object.keys(dataobj).forEach(key => {
                if (key == "detail") {
                  // console.log(dataobj)
                  if (dataobj[key].length != 0) {
                    dataobj[key].forEach((item, index) => {
                      rowobj[item.scene] = `${Math.round(item.percent)}%`;
                      if (item.items && item.items.length != 0) {
                        item.items.forEach((item2, index2) => {
                          rowobj[item2.item] = `${Math.round(
                            item2.fit * 100
                          )}%`;
                          if (item2.detail.length != 0) {
                            item2.detail.forEach((item3, index3) => {
                              rowobj[item3.sentence] = `${Math.round(
                                item3.fit * 100
                              )}%`;
                            });
                          }
                        });
                      }
                    });
                  }
                } else {
                  rowobj[key] = dataobj[key];
                  rowobj["年"] = new Date(dataobj["上传日期"]).Format("YYYY");
                  rowobj["月"] = new Date(dataobj["上传日期"]).Format("MM");
                  rowobj["日"] = new Date(dataobj["上传日期"]).Format("DD");
                  rowobj["时间"] = new Date(dataobj["上传日期"]).Format(
                    "hh:mm:ss"
                  );
                  if (idx === 0) {
                    Tablehead.push(key);
                    if (key === "上传日期") {
                      Tablehead.push("年");
                      Tablehead.push("月");
                      Tablehead.push("日");
                      Tablehead.push("时间");
                    }
                  }
                }
              });
              tabledata.push(rowobj);
            });
          }
          TABLEHEAD = [...Tablehead, ...TABLEHEAD];
          TABLEHEADSHOW = [...Tablehead, ...TABLEHEADSHOW];
          // console.log(TABLEHEAD, TABLEHEADSHOW);
          // return
          this.DownLoadFile(
            TABLEHEAD,
            TABLEHEADSHOW,
            tabledata,
            `${this.form.cid || "all"}-${type}`
          );
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    },

    // 通话记录
    downLoadCallLog() {
      let formdata = new FormData();
      // action: getCallfeelist2
      // vdate0: 2021 - 05 - 01
      // vdate1: 2021 - 05 - 13
      // act:
      // voicetype:
      // pagesize: 10
      // pageno: 1
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      formdata.append("action", "getCallfeelist2");
      formdata.append("vdate0", this.form.Timer[0]);
      formdata.append("vdate1", this.form.Timer[1]);
      formdata.append("brand", this.form.brand);
      formdata.append("zone", this.form.zone);
      formdata.append("act", "");
      formdata.append("cid", this.form.cid);
      formdata.append("voicetype", "");
      formdata.append("pagesize", "10");
      formdata.append("pageno", "");
      this.$axios
        .formatPostData("manage/SetInData.aspx", formdata)
        .then(res => {
          console.log(res);
          loading.close();
          let data = res.data;
          data.list.forEach(item => {
            const obj = this.GetTimeLong(item.startTime, item.callEndTime);
            item.year = new Date(item.callInTime).Format("YYYY");
            item.month = new Date(item.callInTime).Format("MM");
            item.day = new Date(item.callInTime).Format("DD");
            item.longtime = `${obj.hh}:${obj.mm}:${obj.ss}`;
          });
          let HEADER = [
            "录音类型",
            "商家代码",
            "商家名称",
            "呼叫人",
            "本机号码",
            "虚拟号码",
            "客户电话",
            "通话时长",
            "DCC拨打次数",
            "拨打时间",
            "年",
            "月",
            "日"
          ];
          let HEADERFILED = [
            "voicetype",
            "toid",
            "dealername",
            "truename",
            "phone_a",
            "phone_x",
            "phone_b",
            "longtime",
            "callno",
            "callInTime",
            "year",
            "month",
            "day"
          ];
          this.DownLoadFile(
            HEADER,
            HEADERFILED,
            data.list,
            `${this.form.cid}-通话记录`
          );
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    },
    // 线索跟进结果
    downLoadClueResults() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let formdata = new FormData();
      formdata.append("action", "CallDataDownLoad");
      formdata.append("t0", this.form.Timer[0]);
      formdata.append("t1", this.form.Timer[1]);
      formdata.append("brand", this.form.brand);
      formdata.append("zone", this.form.zone);
      formdata.append("cid", this.form.cid);
      this.$axios
        .formatPostData("manage/SetInData.aspx", formdata)
        .then(res => {
          console.log(res);
          loading.close();
          if (res.data.errcode == 0) {
            window.open(window.location.origin + "/" + res.data.fileurl);
          } else {
            this.$message(res.msg || "网络错误，请重试");
          }
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    },
    // 获取时长
    GetTimeLong(stime, etime) {
      //  stime  开始时间
      //  etime  结束时间
      let timer1 = new Date(stime).getTime();
      let timer2 = new Date(etime).getTime();
      const timer = timer2 - timer1; //相差时间数
      let hh = Math.floor(timer / 1000 / 60 / 60);
      let mm = Math.floor((timer - hh * 3600 * 1000) / 60 / 1000);
      let ss = Math.floor((timer - (hh * 24 + mm) * 60 * 1000) / 1000);
      return {
        hh,
        mm,
        ss
      };
    },
    // 计算周
    computerweek(dateTime) {
      let temptTime = new Date(dateTime);
      //周几
      let weekday = temptTime.getDay() || 7;
      //周1+5天=周六
      temptTime.setDate(temptTime.getDate() - weekday + 1 + 5);
      let firstDay = new Date(temptTime.getFullYear(), 0, 1);
      let dayOfWeek = firstDay.getDay();
      let spendDay = 1;
      if (dayOfWeek != 0) {
        spendDay = 7 - dayOfWeek + 1;
      }
      firstDay = new Date(temptTime.getFullYear(), 0, 1 + spendDay);
      let d = Math.ceil((temptTime.valueOf() - firstDay.valueOf()) / 86400000);
      let result = Math.ceil(d / 7);
      return result + 1;
    },
    //接待数据录入
    GetAllInfo() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let formdata = new FormData();
      formdata.append("action", "getuser2");
      formdata.append("vdate0", this.form.Timer[0]);
      formdata.append("vdate1", this.form.Timer[1]);
      formdata.append("act", "");
      formdata.append("vtype", "");
      formdata.append("truename", "");
      formdata.append("brand", this.form.brand);
      formdata.append("zone", this.form.zone);
      formdata.append("dealercode", this.form.cid);
      this.$axios
        .formatPostData("manage/SetInData.aspx", formdata)
        .then(res => {
          console.log(res);
          loading.close();
          if (res.data.errcode == 0) {
            let downloadlist = res.data.list;
            downloadlist.forEach(item => {
              let dataarr = [];
              dataarr = item.vdate.split("-");
              if (item.Uploadcount) {
                item.percentage =
                  parseInt((item.Uploadcount / item.rcount) * 100) || 0 + "%";
              } else {
                item.percentage = 0 + "%";
              }
              item.year = dataarr[0];
              item.month = dataarr[1];
              item.day = dataarr[2];
              item.week = this.computerweek(item.vdate);
            });
            let HEADER = [
              "企业代码",
              "经销商名称",
              "职位",
              "姓名",
              "年",
              "月",
              "日",
              "周",
              "前台登记数",
              "接待语音数",
              "语音上传率"
            ];
            let HEADERFILED = [
              "cid",
              "dealername",
              "act",
              "truename",
              "year",
              "month",
              "day",
              "week",
              "rcount",
              "Uploadcount",
              "percentage"
            ];
            this.DownLoadFile(
              HEADER,
              HEADERFILED,
              downloadlist,
              `${this.form.cid}-接待数据录入`
            );
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    }
  },
  created() {
    this.getBrandFun();
  }
};
</script>
<style scoped>
.el-select {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}

.dateCss {
  display: flex;
}

.dateCss span {
  display: inline-block;
  padding: 0 10px;
  background-color: #fff;
  border: 1px solid #4a8df0;
  color: #4a8df0;
  cursor: pointer;
  border-radius: 2px;
}

.dateCss .timeAct {
  background-color: #4a8df0;
  color: #fff;
}

.tabs {
  display: flex;
  width: 266px;
  justify-content: space-around;
}
</style>
